import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import type { IntlShape } from 'react-intl'
import { injectIntl } from 'react-intl'
import {
    CatalogSelectableOption,
    MorePersonalized
} from 'app/ecommerce/common/components/catalog'
import {
    findIdOptionSelected,
    updateOptionSelected
} from 'shared/utils/ecommerce/utils'
import type { Option } from 'shared/store/ecommerce/catalog'
import _ from 'lodash'

const maxOptionsToDisplay = 3

type Props = {
    intl: IntlShape,
    listOptions: Array<Option>,
    updateOrderOption: (
        id: string,
        quantity?: number,
        quantityInit: number,
        name: string,
        index?: number,
        idToRemove?: string
    ) => void,
    index: number
}

type State = {
    options: Array<any>,
    optionsSliced: Array<any>,
    personalize: boolean
}

class _CatalogGroupOptions extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = this.getInitialState()
    }

    getInitialState = () => {
        const { listOptions } = this.props
        const optionsSliced = listOptions
            ? updateOptionSelected(listOptions).slice(0, maxOptionsToDisplay)
            : []
        return {
            options: updateOptionSelected(listOptions),
            optionsSliced,
            personalize: listOptions.length > maxOptionsToDisplay
        }
    }

    getUpdatedState = () => {
        const { listOptions } = this.props
        const optionsSliced = updateOptionSelected(listOptions)
        return {
            options: updateOptionSelected(listOptions),
            optionsSliced: optionsSliced,
            personalize: false
        }
    }

    componentDidUpdate(prevProps: Props) {
        const { listOptions } = this.props
        if (!_.isEqual(prevProps.listOptions, listOptions)) {
            this.setState(this.getUpdatedState())
        }
    }

    onOptionSelected = (id: string, name: string, isSelected: boolean) => {
        const { updateOrderOption, index } = this.props
        const { options, personalize } = this.state
        const idToRemove = findIdOptionSelected(options)
        const updated = updateOptionSelected(options, id, isSelected)
        this.setState({
            options: updated,
            optionsSliced: personalize
                ? updated.slice(0, maxOptionsToDisplay)
                : updated
        })
        updateOrderOption(id, 1, 0, name, index, idToRemove)
    }

    addOptionsToPersonalize = (moreProducts: boolean) => {
        const { options } = this.state
        this.setState({
            personalize: !moreProducts,
            optionsSliced: moreProducts
                ? options
                : options.slice(0, maxOptionsToDisplay)
        })
    }

    render() {
        const { personalize, optionsSliced } = this.state
        const { intl } = this.props
        return (
            <Fragment>
                <TilesContainer>
                    {optionsSliced.map(({ id, name, image, isSelected }) => {
                        return (
                            <CatalogSelectableOption
                                id={id}
                                name={name}
                                key={id}
                                isSelected={isSelected}
                                onOptionSelected={(isSelected: boolean) =>
                                    this.onOptionSelected(id, name, isSelected)
                                }
                                imageUrl={image}
                            />
                        )
                    })}
                    {personalize && (
                        <MorePersonalized
                            name={intl.formatMessage({
                                id: 'clickandcollect.catalog.options.more'
                            })}
                            onPress={() => this.addOptionsToPersonalize(true)}
                            isMore={true}
                        />
                    )}
                    {!personalize &&
                        optionsSliced.length > maxOptionsToDisplay && (
                            <MorePersonalized
                                name={intl.formatMessage({
                                    id:
                                        'clickandcollect.catalog.product.personalize.less'
                                })}
                                onPress={() =>
                                    this.addOptionsToPersonalize(false)
                                }
                                isMore={false}
                            />
                        )}
                </TilesContainer>
            </Fragment>
        )
    }
}

const TilesContainer = styled.div`
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 20px;
`

const CatalogGroupOptions = injectIntl(_CatalogGroupOptions)
export { CatalogGroupOptions }
